import { render, staticRenderFns } from "./affix.vue?vue&type=template&id=6c408271&"
import script from "./affix.vue?vue&type=script&lang=js&"
export * from "./affix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c408271')) {
      api.createRecord('6c408271', component.options)
    } else {
      api.reload('6c408271', component.options)
    }
    module.hot.accept("./affix.vue?vue&type=template&id=6c408271&", function () {
      api.rerender('6c408271', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/affix/affix.vue"
export default component.exports